<template>
    <q-btn-dropdown
            :icon="orderItem.icon"
            :label="orderItem.title"
            :title="orderItem.title"
            v-bind="$attrs">
        <q-list dense>
            <q-item
                    :active="order === 'asc'"
                    clickable v-close-popup
                    @click="change('asc')">
                <q-item-section side>
                    <q-icon size="xs" :name="this.ascendingIcon"/>
                </q-item-section>
                <q-item-section>
                    <q-item-label>Chronological</q-item-label>
                </q-item-section>
            </q-item>
            <q-item
                    :active="order === 'desc'"
                    clickable v-close-popup
                    @click="change('desc')">
                <q-item-section side>
                    <q-icon size="xs" :name="this.descendingIcon"/>
                </q-item-section>
                <q-item-section>
                    <q-item-label>Reverse-Chronological</q-item-label>
                </q-item-section>
            </q-item>
        </q-list>
    </q-btn-dropdown>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

interface Order {
  icon: string,
  title: string,
}

export default defineComponent({
  emits: ['changed'],
  props: {
    order: {
      type: String,
      default: 'asc',
    },
  },
  data() {
    return {
      ascendingIcon: 'fas fa-sort-amount-down',
      descendingIcon: 'fas fa-sort-amount-up',
    };
  },
  computed: {
    orderItem(): Order {
      if (this.order === 'asc') {
        return {
          icon: this.ascendingIcon,
          title: 'Chronological',
        };
      }
      return {
        icon: this.descendingIcon,
        title: 'Reverse-Chronological',
      };
    },
  },
  methods: {
    change(order: string): void {
      this.$emit('changed', order);
    },
  },
});
</script>
